import { api, API_BASE_URL } from './client';
import { fetchCompleteCollection } from './pagination';

type UserListParams = { role?: string; search?: string; page?: number; limit?: number };
type CompleteUserListParams = Omit<UserListParams, 'page' | 'limit'>;

const getUsers = (params?: UserListParams) =>
  api.get<{ users: import('../types').User[]; pagination: import('../types').PaginationInfo }>(
    '/users',
    params,
  );

// Users API
export const usersApi = {
  getAll: getUsers,

  getAllAccessible: async (params?: CompleteUserListParams) => ({
    users: await fetchCompleteCollection(async (page, limit) => {
      const response = await getUsers({ ...params, page, limit });
      return { items: response.users, pagination: response.pagination };
    }),
  }),

  update: (id: string, data: Partial<import('../types').User>) =>
    api.patch<{ user: import('../types').User }>(`/users/${id}`, data),

  uploadAvatar: async (
    file: File,
  ): Promise<{
    message: string;
    avatar_url: string;
    user: import('../types').User;
  }> => {
    const token = api.getToken();
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_BASE_URL}/users/me/avatar`, {
      method: 'POST',
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error((errorData as { error?: string }).error || 'Failed to upload avatar');
    }

    return response.json();
  },
};
